import { Button, Flex, Spin, Tag } from "antd"
import { Alert } from "~/components/Alert"
import { Text } from "~/components"
import { useTemplateCategories } from "~/store/templateCategories"
import styles from "./index.css"

export const TemplateFilters = ({
  selected,
  onChange,
}: {
  // 当前分类，为空表示全部
  selected: string
  onChange: (category: string) => void
}) => {
  const { categories, status, error, reload } = useTemplateCategories()
  return (
    <Flex
      vertical
      gap={12}
      className={styles.filters}
    >
      <Flex
        align="center"
        gap={20}
        className={styles.filterBar}
      >
        <Flex
          align="center"
          gap={8}
          className={styles.filterOptions}
          role="group"
          aria-label="模板分类筛选"
        >
          <Tag.CheckableTag
            className={styles.filterTag}
            checked={!selected}
            onChange={() => onChange("")}
          >
            全部
          </Tag.CheckableTag>
          <Tag.CheckableTagGroup
            aria-label="模板分类"
            classNames={{
              root: styles.filterTagGroup,
              item: styles.filterTag,
            }}
            options={categories}
            value={selected || null}
            // 再次点击当前分类不取消选中，保持始终有一个选中项
            onChange={(category) => {
              if (category) onChange(category)
            }}
          />
          {(status === "idle" || status === "loading") && (
            <Spin
              size="small"
              aria-label="加载模板分类中"
            />
          )}
        </Flex>
        <Flex
          align="center"
          gap={8}
          className={styles.updateNote}
        >
          <span
            className={styles.updateDot}
            aria-hidden
          />
          <Text type="secondary">每周持续上新</Text>
        </Flex>
      </Flex>
      {status === "error" && (
        <Alert
          level="weak"
          title="模板分类加载失败"
          description={error}
          showIcon
          action={<Button onClick={() => void reload()}>重试</Button>}
        />
      )}
    </Flex>
  )
}
